import { Constants } from "../../data/constants";
import { HttpService } from "../../utils/HttpService";

export class CustomerService {
  constructor() {
    this.constants = new Constants();
    this.HttpService = new HttpService();
  }
  getAllCustomersService = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.customerServiceURLS.getCustomers,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getAllCustomersForTickets = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.customerServiceURLS.getAllCustomers,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  getCustomerById = async (session_id, customerId) => {
    try {
      return await this.HttpService.getJson(
        this.constants.customerServiceURLS.getCustomersById + `${customerId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getAllCustomerSegmentsService = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.customerServiceURLS.getAllCustomerSegments,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  createCustomer = async (
    session_id,
    customer,
    apiUrl = this.constants.customerServiceURLS.postCustomer
  ) => {
    try {
      return await this.HttpService.postJson(
        apiUrl,
        {
          accountId: customer.accountId,
          userId: customer.userId,
          customerId: customer.customerId,
          customerFullname: customer.customerFullname,
          customerNumber: customer.customerNumber,
          customerEmail: customer.customerEmail,
          customerAddress: customer.customerAddress,
          customerSegment: customer.customerSegment,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  editCustomer = async (session_id, customer) => {
    try {
      return await this.HttpService.putJson(
        this.constants.customerServiceURLS.editCustomer,
        {
          accountId: customer.accountId,
          customerId: customer.customerId,
          customerEmail: customer.customerEmail,
          customerFullname: customer.customerFullname,
          customerNumber: customer.customerNumber,
          customerAddress: customer.customerAddress,
          customerSegment: customer.customerSegment,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  deleteCustomer = async (session_id, customerId) => {
    try {
      return await this.HttpService.deleteJson(
        this.constants.customerServiceURLS.getCustomers + `${customerId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
}
